import { KALENDER_GET } from './reduxConstant';

export const kalenderGet = (calendar) => {
  return {
    type: KALENDER_GET,
    payload: {
      calendar,
    },
  };
};
